<template>
  <skeleton-box>
    <v-layout row wrap>
      <v-flex pr-2 pb-2 md4>
        <skeleton-line class="big"></skeleton-line>
      </v-flex>
      <v-flex pr-2 pb-2 md4>
        <skeleton-line class="big"></skeleton-line>
      </v-flex>
      <v-flex md4>
        <v-layout row wrap>
          <v-flex md12 pb-2>
            <skeleton-line class="little"></skeleton-line>
          </v-flex>
          <v-flex md12 pb-2>
            <skeleton-line class="little"></skeleton-line>
          </v-flex>
          <v-flex md12 pb-2>
            <skeleton-line class="little"></skeleton-line>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
  </skeleton-box>
</template>
<script>
import SkeletonLine from '@/components/global/skeletons/Line';
import SkeletonBox from '@/components/global/skeletons/SkeletonBox';

export default {
  components: {
    SkeletonLine,
    SkeletonBox,
  },
};
</script>
<style scoped>
.big {
  height: 500px;
}
.little {
  height: 160px;
}
</style>




// WEBPACK FOOTER //
// src/components/reports/segmentation/distribution/SkeletonDistribution.vue